
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import PayPal from './integrations/PayPal';
import Wompi from './integrations/Wompi';
import Addi from './integrations/Addi/AddiIndex'
import FormUpdate from './payment_infos/FormUpdate';
import { isMobile } from 'react-device-detect';
import Preloader from '../../general/Preloader';

const PaymentForm = forwardRef((props, ref) => {
    const [use_payment_information, setUsePaymentInformation] = useState(props.user.payment_info.use_payment_information);
    const [modal, setModal] = useState();
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(false);
    const [indexPaymentGateway, setIndexPaymentGateway] = useState(0);

    const customerData = {
        user_platform_id: props.user.id,
        discount_code_id: props.discount_code ? props.discount_code.id : "",
        affiliate_id: props.affiliate ? props.affiliate.id : "",
        price_id: props.price.id,
    };

    console.log(customerData)

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://payment.flywire.com/assets/js/checkout.js';
        script.async = true;
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const updateStateCheckbox = (e) => {
        var form = { use_payment_information: e.target.checked, price_id: props.price.id, discount_code_id: props.discount_code.id, }
        fechUpdatePaymentInfo(form)
    }

    const handleClickUpdatePaymentInfo = (form) => {
        fechUpdatePaymentInfo(form)
    }

    const fechUpdatePaymentInfo = (form) => {
        fetch(`/api/v1/payment_infos/${props.user.payment_info.id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(form), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            if(data.type == "success"){
                props.setUserState(data.register);
                setUsePaymentInformation(data.register.payment_info.use_payment_information)
            }
        });
    }

    const paymentGenerate = () => {
        setIsLoaded(true)
        fetch(`/api/v1/payment_generate`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(customerData), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            props.toogleTab("payment_completed")
            setIsLoaded(false);
        });
    }

    const handlePaymentAddi = () => {
        window.location.href = "https://www.addi.com/pago"; // Reemplaza con la URL real de Addi
    }
    
    const handlePayment = () => {
        const config = {
            displayPayerInformation: true,
            // Set your environment (demo, production)
            env: props.mode,
            // Set your unique 3 letter code (may differ between environments)
            recipient: props.user.country.recipient,
            // Set your preferred locale
            locale: "es-ES",
            // Set provider to checkout
            provider: "embed2.0",
            // Define Payer/Sender fields
            amount: props.prices.flywire,
            sedner_country: props.price.currency.code,
            
            sender_first_name: props.user.name,
            sender_middle_name: "",
            sender_last_name: props.user.lastnames,
            sender_address1: props.user.address,
            sender_address2: "202",
            sender_state: "Spitalfields",
            sender_zip: "E1 6GL",
            sender_phone: `${props.user.country.phone_code}${props.user.phone}`,
            sender_city: props.user.city.name,

            sender_email: props.user.email,
            // Define custom attributes (based on your portal settings)
            // Dynamic - Student Fields
            user_platform_id: props.user.id,
            discount_code_id: props.discount_code.id,
            affiliate_id: props.affiliate ? props.affiliate.id : "",
            price_id: props.price.id,
            
            // Enable payment status notification callbacks
            callback_id: props.reference,
            callback_version: "2",
            callback_url: props.webhooks.flywire,
            // Set the return url to redirect the user on process completion
            return_url: props.return_url,
        };
    
        window.flywire.Checkout.render(config, '#checkout-button');
    };

    const renderIntegrationPayment = (payment_gateway) => {
        if(payment_gateway.name == "Wompi"){
            return(
                <Wompi
                    user={props.user}
                    price={props.price}
                    prices={props.prices}
                    discount_code={props.discount_code}
                    affiliate={props.affiliate}
                    cadena={props.cadena}
                    pub_test={props.pub_test}
                    reference={props.reference}
                    return_url={props.return_url}
                    customerData={customerData}
                />
            )
        }else if (payment_gateway.name == "Flywire"){
            return(
                <React.Fragment>
                    <button 
                        id="checkout-button" 
                        className='btn btn-primary btn-payment btn-lg btn-block' 
                        onClick={handlePayment}
                        style={{ height: 55 }}
                    >
                        <strong className='text-white'>Pagar</strong>
                    </button>
                </React.Fragment>
            )

        }else if (payment_gateway.name == "PayPal"){
            return(
                <React.Fragment>
                    <PayPal
                        user={props.user}
                        price={props.price}
                        prices={props.prices}
                        customerData={customerData}
                        reference={props.reference}
                        client_paypal={props.client_paypal}
                        toogleTab={props.toogleTab}
                    />
                </React.Fragment>
            )

        }else if (payment_gateway.name == "Addi"){
            return(
                <React.Fragment>
                    <Addi
                        user={props.user}
                        price={props.price}
                        prices={props.prices}
                        discount_code={props.discount_code}
                        affiliate={props.affiliate}
                        reference={props.reference}
                    />
                </React.Fragment>
            )
        }
    }

    const renderName = (payment_gateway_name) => {
        if(payment_gateway_name == "Flywire" || payment_gateway_name == "Wompi"){
            return "Comprar"
        }else{
            return payment_gateway_name
        }
    }

    const toogle = () => {
        setModal(!modal)
    }
    
    return (
        <React.Fragment>
            {modal && (
                <FormUpdate
                    //modal props
                    backdrop={"static"}
                    modal={modal}
                    toggle={toogle}
                    title={"Actualizar información"}
                    nameBnt={"Actualizar"}
                    user={props.user}

                    //modal update payment info
                    countries={props.countries}
                    document_types={props.document_types}
                    cities={props.cities}

                    //price 
                    price={props.price}
                />
            )}

            <div className='card'>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4">
                            <img 
                                className='img-thumbnail'
                                src={props.user.avatar.url} 
                                alt={props.user.name}
                            />
                        </div>

                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-4">
                                    <strong className='label-user-info'>Nombre</strong>
                                    <p className='text-dark'>{props.user.name}</p>
                                </div>

                                <div className="col-md-4">
                                    <strong className='label-user-info'>Apellido</strong>
                                    <p className='text-dark'>{props.user.lastnames}</p>
                                </div>

                                <div className="col-md-4">
                                    <strong className='label-user-info'>Documento</strong>
                                    <p className='text-dark'>{props.user.document}</p>
                                </div>

                                <div className="col-md-12">
                                    <strong className='label-user-info'>Correo</strong>
                                    <p className='text-dark'>{props.user.email}</p>
                                </div>

                                <div className="col-md-12">
                                    <strong className='label-user-info'>¿Utilizar informacion de pago?</strong>
                                    <div className="custom-control custom-switch">
                                        <input type="checkbox" className="custom-control-input" id={`customSwitchPayment`} name='visible' onChange={(e) => updateStateCheckbox(e)} checked={use_payment_information}/>
                                        <label className="custom-control-label" for={`customSwitchPayment`}>{""}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        {use_payment_information && (
                            <div className="col-md-12">
                                <div className="alert alert-primary text-white text-center" role="alert">
                                    Estimado usuario, queremos informarte que la pasarela de pagos utilizará la información del pago, si deseas actualizar tu información, puedes hacerlo accediendo al siguiente enlace: <a onClick={() => toogle()} className='btn-payment-link'>editar información</a>
                                </div>
                            </div>    
                        )}

                        {(props.prices.wompi >= 1 && !props.user.validation.show) ? (
                            <div className="col-md-12 payment_gateways">
                                <React.Fragment>
                                    {props.user.country.payment_gateways.length >= 1 ? (
                                        <React.Fragment>
                                            <ul className="nav nav-tabs mb-3" id="myTab" role="tablist">
                                                {props.user.country.payment_gateways.map((payment_gateway, index) => (
                                                    <li className="nav-item" key={payment_gateway.id}>
                                                        <a 
                                                            className={`nav-link text-primary ${index == indexPaymentGateway ? "active" : ""}`} 
                                                            id={`home-tab-${payment_gateway.name}`} 
                                                            data-toggle="tab" 
                                                            href="#home" 
                                                            role="tab" 
                                                            aria-controls="home" 
                                                            aria-selected={index == indexPaymentGateway ? "true" : ""}
                                                            style={{ fontSize: 14 }}
                                                            onClick={() => setIndexPaymentGateway(index)}
                                                        >
                                                            {renderName(payment_gateway.name)}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>

                                            <div className="col-md-12 p-0">
                                                <div className="tab-content" id="myTabContent">
                                                    {props.user.country.payment_gateways.map((payment_gateway, index) => (
                                                        <div className={`tab-pane ${index == indexPaymentGateway ? "fade show active" : ""}`} id="home" role="tabpanel" aria-labelledby={`home-tab-${payment_gateway.name}`} key={payment_gateway.id}>

                                                            {payment_gateway.description && (
                                                                <div className="description">
                                                                    <div className="alert alert-primary text-white text-center" role="alert">
                                                                        <b className='text-white'>{payment_gateway.description}</b>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {renderIntegrationPayment(payment_gateway)}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        <div className="card">
                                            <div className="card-body text-center">
                                                <h5 className='text-primary'>No hay apasarela de pagos configurado par el pais {props.user.country.name.toLowerCase()}</h5>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            </div>
                        ) : (
                            <div className="col-md-12">
                                <div className={`alert alert-${isLoaded ? "success" : props.user.validation.type} text-${isLoaded ? "dark" : "white"} text-center`} role="alert">
                                    <b className='text-white'>{isLoaded ? "Estamos procesando tu solicitud. Este paso puede tardar unos minutos, ya que estamos generando todo lo necesario para que tengas acceso a tus cursos. ¡Gracias por tu paciencia! 😊" : props.user.validation.message}</b> {isLoaded ? <br /> : null}
                                    {props.user.validation.button && (
                                        <React.Fragment>
                                            {isLoaded ? (
                                                <React.Fragment>
                                                    <Preloader/>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <br />
                                                    <button 
                                                        className='btn btn-success text-white mt-3' 
                                                        onClick={() => paymentGenerate()}
                                                        disabled={isLoaded}
                                                    >
                                                        {isLoaded ? "Generando.." : "Confirmar"}
                                                    </button>
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});


export default PaymentForm;